// @ts-check
import { createContext } from "react"

export const ChatBubbleStreamingContext = createContext(false)
